import React from 'react';
import moment from 'moment';
import { Filters, FiltersLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import usePerformanceReportService from 'domain/people/performanceReport/usePerformanceReportService';
import PerformanceReportsListHeatmap from './PerformanceReportsListHeatmap';
import { DATE_FORMAT } from 'framework/utils';
import EmployeeTypeFilter from 'domain/people/employee/List/filter/EmployeeTypeFilter';
import { EmployeePositionFilter, DISMISSED_STATUS, OfficeFilterById } from 'domain/shared/employee';
import EmployeeProbationFilter from 'domain/people/employee/List/filter/EmployeeProbationFilter';
import EmployeeWorkingStatusFilter from 'domain/people/employee/List/filter/EmployeeWorkingStatusFilter';
import PerformanceMetricFilter from 'domain/people/performanceReport/List/filter/PerformanceMetricFilter';

const PerformanceReportsListPage = () => {
  const { search } = usePerformanceReportService();
  const currentMonth = moment().format(DATE_FORMAT.API_ONLY_MONTH);

  const filters = (
    <FiltersLayout>
      <EmployeeWorkingStatusFilter source="workingStatus" label="Working status" excluded={[DISMISSED_STATUS]} />
      <EmployeeTypeFilter source="employeeType" label="Type" />
      <EmployeePositionFilter source="position.id" label="Position" />
      <EmployeeProbationFilter source="specification:hasActiveProbation" label="Probation" />
      <OfficeFilterById source="specification:office" label="Current office" />
      <PerformanceMetricFilter source="metrics" label="Metric" />
    </FiltersLayout>
  );

  return (
    <List
      getDataMethod={search}
      defaultFilter={{
        period: {
          eq: currentMonth,
        },
      }}
      uncontrolledFilters={['period']}
    >
      <Filters>
        <ListPageLayout header={<ListHeader label="Performance Report" />} filter={filters}>
          <PerformanceReportsListHeatmap />
        </ListPageLayout>
      </Filters>
    </List>
  );
};

export default PerformanceReportsListPage;
